// extracted by css-extract-rspack-plugin
var _1 = "Farming-m_farming-zwEbY_Uj";
export { _1 as "farming" }
